(function () {

    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": []
    };

    const faqItems = [...document.querySelectorAll('.faq-question')];
    const faqContents = [...document.querySelectorAll('.faq-answer')];

    if (!faqItems.length || !faqContents.length) return;

    faqItems.forEach((item, index) => {
        const answerElement = faqContents[index];

        if (!answerElement) return;

        const question = item.textContent.trim();

        const clone = answerElement.cloneNode(true);
        clone.querySelectorAll('img, picture, source').forEach(el => el.remove());

        const answer = clone.innerHTML.trim();

        if (question && answer) {
            schema.mainEntity.push({
                "@type": "Question",
                "name": question,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": answer
                }
            });
        }
    });

    if (!schema.mainEntity.length) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);

    document.head.appendChild(script);

})();